import React from 'react'
import { Alert } from '@ztechapps/webui.util'
import { useOrderShippingRates } from '../../hooks/useOrderShippingRates'

export const ShippingRatePanelEmptyResult = () => {
  const [, { error }] = useOrderShippingRates()

  return (
    <Alert type="warning">
      <h4>No shipping options are available for this order. Please contact the store for help.</h4>
      <div className={'text-danger'}>{error?.message?.toString()}</div>
    </Alert>
  )
}
